import React, { useState } from 'react';
import { PrioridadeSolicitacao } from 'model/solicitacao/PrioridadeSolicitacao';
import { Paginacao } from 'view/component/Paginacao/Paginacao';


interface PrioridadesListaProps {
  // filtros?: PrioridadesSolicitacaoQueryParams
}

export const PrioridadesLista: React.FC<PrioridadesListaProps> = () => {
  const [page, setPage] = useState(1)
  //page - 1 porque a paginacao no spring começa com a página 0
  //TODO: achar uma solução melhor para isso
  const error = "Erro!";
  const loading = true;
  const data = {content: [], totalPages: 5}

  function renderItem(prioridade: PrioridadeSolicitacao) {
    return (
      <tr id={"prioridade-"+prioridade.id} key={prioridade.id}>
        <td className="center">{prioridade.nome}</td>
        <td className="left">{prioridade.descricao}</td>
      </tr>
    )
  }

  if (loading) {
    return <>Carregando...</>
  }

  return <>
    {error && 'Error!'}
    <p/>
    <table>
        <tbody>
            { data!.content.map(prioridade => renderItem(prioridade)) }
        </tbody>
    </table>
    <Paginacao 
      paginaAtual={page}
      paginas={data?.totalPages ?? 1}
      onChange={(event, newPage) => setPage(newPage)} />
    {/* {
        
      data!.map((prioridade: any) => (<div key={prioridade.id}>{prioridade.descricao}</div>))
    } */}
  
  </>
}
